import { AxiosRequestConfig } from 'axios';

import {
  CONFIRM_PHONE,
  PIN_CODE_SEND,
  PIN_CODE_CONFIRM,
  IN_APP_OTP,
  UPDATE_PASSWORD,
  UPDATE_PHONE,
  UPDATE_PIN,
  DISABLE,
  REGISTER,
} from './consumer.request-urls';
import { restClient, restClientCaptcha } from '../rest-client';
import {
  IChangePasswordData,
  IChangePasswordResponse,
  IChangePhoneData,
  IChangePhoneResponse,
  IChangePhoneConfirmData,
  IRegistrationData,
  IRegistrationResponse,
  IDeleteConsumerData,
  IDeleteConsumerResponse,
  ISendPinCodeData,
  ISendPinCodeResponse,
  ConfirmPinCodeData,
  IConfirmPinCodeResponse,
  IUpdatePasswordData,
  IUpdatePasswordResponse,
  InAppOtpData,
  InAppOtpResponse,
} from './consumer.models';
import { getAuthorizationHeader } from '../../utils/request-headers/get-authorization-header';
import { getTokenFromStorage } from '../../utils/user';
import { CaptchaType } from '../../graphql/configuration';

export const consumerApi = {
  sendPinCode(data: ISendPinCodeData) {
    return restClient.post<ISendPinCodeResponse>(PIN_CODE_SEND, data);
  },
  sendPinCodeCaptcha(data: ISendPinCodeData, token: string, captchaType?: CaptchaType) {
    return restClientCaptcha(token, captchaType).post<ISendPinCodeResponse>(PIN_CODE_SEND, data);
  },
  confirmPinCode(data: ConfirmPinCodeData) {
    return restClient.post<IConfirmPinCodeResponse>(PIN_CODE_CONFIRM, data);
  },
  updatePassword(data: IUpdatePasswordData) {
    return restClient.post<IUpdatePasswordResponse>(UPDATE_PASSWORD, data);
  },
  changePassword(data: IChangePasswordData) {
    return restClient.post<IChangePasswordResponse>(UPDATE_PIN, data, {
      headers: {
        Authorization: getAuthorizationHeader(),
      },
    });
  },
  changePhoneNumber(data: IChangePhoneData) {
    return restClient.post<IChangePhoneResponse>(UPDATE_PHONE, data, {
      headers: {
        Authorization: getAuthorizationHeader(),
      },
    });
  },
  confirmPhoneNumber(data: IChangePhoneConfirmData) {
    const isApiGateway = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true';
    const refreshToken = isApiGateway ? getTokenFromStorage()?.refresh_token : undefined;

    return restClient.post<IRegistrationResponse>(CONFIRM_PHONE, {
      ...data,
      ...(refreshToken && { refresh_token: refreshToken }),
    }, {
      headers: {
        Authorization: getAuthorizationHeader(),
      },
    });
  },
  register(data: IRegistrationData, config: AxiosRequestConfig) {
    return restClient.post<IRegistrationResponse>(REGISTER, data, config);
  },
  delete(data: IDeleteConsumerData) {
    return restClient.delete<IDeleteConsumerResponse>(DISABLE, {
      headers: {
        Authorization: getAuthorizationHeader(),
      },
      data,
    });
  },

  inAppOtpRequest(data: InAppOtpData) {
    return restClient.post<InAppOtpResponse>(IN_APP_OTP, data, {
      headers: {
        Authorization: getAuthorizationHeader(),
      },
    });
  },
};
